import React, { FC } from 'react';
import { Helmet } from 'react-helmet';
import { useAppTitle } from '../../hooks';

export const AppMeta: FC = () => {
  const { title } = useAppTitle();

  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};
